
export const imageUtils = {
  images: {
    wuLogo: require('../resources/images/wuLogo.png'),
    wuLogoBlack: require('../resources/images/wuLogoBlack.png'),
    landingPageBackground: require('../resources/images/landingPageBackground.jpg'),
    emptyProfileIcon: require('../resources/images/blankPersonLarge.png'),
  },
};
